<template>
  <SlidersDefault>
    <SwiperSlide
      v-for="message in ambition.children"
      :key="message.id"
      class="!h-auto"
    >
      <div class="mx-auto flex h-full max-w-xs flex-col justify-between bg-white">
        <img
          v-if="message.active_image"
          class="image aspect-long h-max lg:col-span-3 lg:aspect-[4/3]"
          :src="message.active_image?.url"
          :alt="message.active_image?.name"
        >
        <div class="flex h-full flex-col justify-between p-8">
          <div class="heading lg:text-2xl">
            {{ message.title }}
          </div>
          <SofieText
            class="prose mb-8 line-clamp-5 max-w-full text-xs lg:text-lg"
            :value="message.short_text"
          />
          <NuxtLink
            class="text-[#849DBF] underline"
            :to="localePath({name: 'ambitions-ambition-slug', params: {ambition: ambition.slug, slug: message.slug}})"
          >
            {{ $t('Read more') }}
          </NuxtLink>
        </div>
      </div>
    </SwiperSlide>
  </SlidersDefault>
</template>

<script setup lang="ts">
import type {Werkveld} from '~/graphql/graphql';

const localePath = useLocalePath();

defineProps<{
  ambition: Werkveld
}>();
</script>
